import { createContext, useContext } from 'react';

/**
 * "Há mudança não salva no workflow."
 *
 * O modal descobria isso escutando `input`/`change` que sobem dos campos. Isso
 * cobre o que se digita, e deixa de fora o que muda por clique: substituir uma
 * etapa inteira pela anterior ou arrastar uma linha não disparam evento de
 * campo nenhum — e fechar o modal descartava o trabalho sem aviso.
 *
 * Quem muda a tela por clique chama `marcarAlterado()`. Fora do modal (num
 * teste, ou se a aba for usada sozinha) o padrão é não fazer nada.
 */
const AlteracaoDoWorkflow = createContext(() => {});

export const AlteracaoDoWorkflowProvider = AlteracaoDoWorkflow.Provider;

export const useMarcarAlterado = () => useContext(AlteracaoDoWorkflow);
